import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

interface EnvVarStatus {
  present: boolean;
  value: string | null;
}

export interface WhatsappConfigStatus {
  WHATSAPP_API_TOKEN: EnvVarStatus;
  WHATSAPP_PHONE_NUMBER_ID: EnvVarStatus;
  WHATSAPP_BUSINESS_ACCOUNT_ID: EnvVarStatus;
  WHATSAPP_APP_SECRET: EnvVarStatus;
  WHATSAPP_WEBHOOK_VERIFY_TOKEN: EnvVarStatus;
  WHATSAPP_API_VERSION: EnvVarStatus;
}

type QueryResponse = {
  status: number;
  data: WhatsappConfigStatus;
};

export const createWhatsappConfigKey = (additional: any[] = []) => [
  'whatsapp-config',
  ...additional,
];

export const useGetWhatsappConfigQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while fetching WhatsApp Config',
    endpoint: `/api/admin/whatsapp/config`,
  });

  return useQuery({
    queryKey: createWhatsappConfigKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};